module.exports = __webpack_public_path__ + "img/3.d8f33651.png";